<!--分隔符-->
<template>
  <div class="q-content">
    <span v-html="question.title"></span>
  </div>
</template>

<script>
    export default {
        name: "tFengeFu",
        props: {
            question: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
  .q-content {
    padding: 15px 0;
  }
</style>
